<template>
  <d2-container>
    <template slot="header">
      <el-input
        @keyup.enter.native="getSearch"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入用户id"
        size="small"
        v-model="listQuery.accountId"
      ></el-input>
      <el-select
        class="filter-item"
        clearable
        v-model="listQuery.changeType"
        placeholder="请选择流水类型"
        @change="selectCustomized"
        style="margin-right: 20px;"
      >
        <el-option
          v-for="item in drillList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button class="filter-item" @click="getSearch" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="luckList"
    >
      <el-table-column align="center" label="用户id" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.accountId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="id" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="流水标题" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="变动后金额" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.afterAmount == 0 ?0: scope.row.afterAmount/10000 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="变动前金额" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.beforeAmount == 0 ?0: scope.row.beforeAmount/10000 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="变动金额" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.changeAmount == 0 ?0: scope.row.changeAmount/10000 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="流水类型" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.changeType == 1? '配对':(scope.row.changeType == 2? '兑换商品' :(scope.row.changeType == 3?'退还':(scope.row.changeType == 4?'完成任务':(scope.row.changeType == 5?'购买商品':(scope.row.changeType == 6?'新人礼包':(scope.row.changeType == 7?'幸运抽奖':(scope.row.changeType == 8?'口令礼包':''))))))) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型" width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.changeType == 1? '账户id':(scope.row.changeType == 2? '订单' :(scope.row.changeType == 3?'订单':(scope.row.changeType == 4?'任务日志':(scope.row.changeType == 5?'订单id':(scope.row.changeType == 6?'账户id':(scope.row.changeType == 7?'抽奖记录':(scope.row.changeType == 8?'兑换记录id':''))))))) }}: {{ scope.row.sourceId}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="备注" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getLead } from '@/api/demo/user/index'
export default {
  name: 'leadDrilslADdd',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      tableKey: 0,
      luckList: [],
      total: null,
      listLoading: true, // 加载圈圈
      listQuery: {
        currentPage: 1, // 当前页数
        accountId: null, // 用户id
        pageSize: 20, // 每页显示的大小
        changeType: null // 流水类型 1配对 2.兑换商品 3.退还 4.完成任务 5.购买商品 6.新人礼包 7.幸运抽奖 8.口令礼包
        // keyword:null,//活动昵称和奖品
      },
      drillList: [
        {
          value: 1,
          label: '配对'
        }, {
          value: 2,
          label: '兑换商品'
        }, {
          value: 3,
          label: '退还'
        }, {
          value: 4,
          label: '完成任务'
        }, {
          value: 5,
          label: '购买商品'
        }, {
          value: 6,
          label: '新人礼包'
        }, {
          value: 7,
          label: '幸运抽奖'
        }, {
          value: 8,
          label: '口令礼包'
        }
      ]
    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  created () {
    this.listQuery.accountId = this.$route.query.id
    // 抽奖活动列表
    this.getList()
  },
  methods: {
    // 抽奖活动列表
    getList () {
      let that = this
      getLead(that.listQuery).then(res => {
        that.listLoading = true
        that.luckList = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
        // console.log("resres", res);
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList()
    },
    // 搜索
    getSearch () {
      this.getList()
    },
    selectCustomized (e) {
      this.listQuery.changeType = e
    }
  }
}
</script>

<style scoped>
.greed {
  color: green;
}
.red {
  color: red;
}
</style>
